export enum ExperienceProof {
  Link = "link",
  Cert = "cert",
  Screen = "screen",
  AckLetter = "ack_letter",
  AppLetter = "app_letter",
}

export enum ExperienceProofPublicTalk {
  Cert = "cert",
  Screenshot = "screenshot",
  AcknowledgmentLetter = "acknowledgment-letter",
  LetterOfAppreciation = "letter-of-appreciation",
  ConfirmationLetter = "confirmation-letter",
  Email = "email",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofArticle {
  Cert = "cert",
  Screenshot = "screenshot",
  AcknowledgmentLetter = "acknowledgment-letter",
  LetterOfAppreciation = "letter-of-appreciation",
  Email = "email",
  Grant = "grant",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofContest {
  VictoryCert = "victory-cert",
  Screenshot = "screenshot",
  AcknowledgmentLetter = "acknowledgment-letter",
  LetterOfAppreciation = "letter-of-appreciation",
  ConfirmationLetter = "confirmation-letter",
  Email = "email",
  Grant = "grant",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofAward {
  VictoryCert = "victory-cert",
  Screenshot = "screenshot",
  AcknowledgmentLetter = "acknowledgment-letter",
  LetterOfAppreciation = "letter-of-appreciation",
  ConfirmationLetter = "confirmation-letter",
  Email = "email",
  Grant = "grant",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofMentorship {
  Cert = "cert",
  Screenshot = "screenshot",
  AcknowledgmentLetter = "acknowledgment-letter",
  LetterOfAppreciation = "letter-of-appreciation",
  ConfirmationLetter = "confirmation-letter",
  Email = "email",
  Testimonials = "testimonials",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofScientificWork {
  Cert = "cert",
  Screenshot = "screenshot",
  AcknowledgmentLetter = "acknowledgment-letter",
  LetterOfAppreciation = "letter-of-appreciation",
  ConfirmationLetter = "confirmation-letter",
  Email = "email",
  Grant = "grant",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofCommunity {
  Screenshot = "screenshot",
  AcknowledgmentLetter = "acknowledgment-letter",
  LetterOfAppreciation = "letter-of-appreciation",
  ConfirmationLetter = "confirmation-letter",
  Email = "email",
  Testimonials = "testimonials",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofOpenSource {
  Link = "link",
  Screenshot = "screenshot",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofPatent {
  Screenshot = "screenshot",
  Cert = "cert",
  Grant = "grant",
  Scholarship = "scholarship",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofOther {
  Link = "link",
  Cert = "cert",
  AcknowledgmentLetter = "acknowledgment-letter",
  LetterOfAppreciation = "letter-of-appreciation",
  LetterOfConfirmation = "letter-of-confirmation",
  Screenshot = "screenshot",
  Scholarship = "scholarship",
  Other = "other",
  SelfSigned = "self-signed",
}

export enum ExperienceProofEntrepreneurship {
  InformationLetterCFO = "information_letter_CFO",
  GrantAgreement = "grant_agreement",
  ProofOfMonetisation = "proof_of_monetisation",
  ProofOfImportantPartnerships = "proof_of_important_partnerships",
  ScreenshotsOfAppAnalytics = "screenshots_of_app_analytics",
  ProofCompanySuccess = "proof_company_success",
  SalesContract = "sales_contract",
  ProofOfRaisedFunds = "proof_of_raised_funds",
}

export enum ExperienceProofEmployment {
  JobOffer = "job_offer",
  EmploymentContract = "employment_contract",
  EmploymentLetters = "employment_letters",
  TaxReport = "tax_report",
  ProofCompensation = "proof_compensation",
  CompanyReports = "company_reports",
  PressReleases = "press_releases",
  FinancialTaxReports = "financialTaxReports",
  OtherReports = "other_reports",
  Messages = "messages",
}
